import { Form } from '@mews/framework';
import { OverlayedLoader } from '@mews-commander/ui';
import { TextMessagingConfiguration } from '@mews-commander/data-access';
import { useEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { useTextMessagingCofigurationUpdate } from '../../queries';
import { AfterStartFormFields } from './AfterStartFormFields';
import { AfterStartFormValues } from './types';

interface OnlineCheckInFormContainerProps {
    enterpriseId: string;
    configuration: TextMessagingConfiguration;
}

export const AfterStartFormContainer = ({ enterpriseId, configuration }: OnlineCheckInFormContainerProps) => {
    const languageCode = useEnterprise(enterpriseId).defaultLanguageCode;
    const { messageTypeConfiguration } = configuration;
    const typeConfiguration = messageTypeConfiguration?.afterStart;
    const { isPending, mutate } = useTextMessagingCofigurationUpdate({ enterpriseId });
    const defaultServiceIds =
        typeConfiguration?.services?.filter((service) => service.isEnabled).map((service) => service.id) ?? [];

    const handleSubmit = (formData: AfterStartFormValues) => {
        mutate({
            serviceIds: {
                value: formData.serviceIds,
            },
            languageCode: formData.languageCode,
            enabledTextMessageTypes: {
                value: {
                    afterStart: {
                        value: formData.isEnabled,
                    },
                },
            },
        });
    };

    return (
        <>
            <OverlayedLoader show={isPending} fixed />
            <Form
                onSubmit={handleSubmit}
                resolver={undefined}
                mode="onTouched"
                defaultValues={{
                    serviceIds: defaultServiceIds,
                    languageCode,
                    isEnabled: typeConfiguration?.isEnabled ?? false,
                }}
            >
                {({ submit, reset }) => (
                    <AfterStartFormFields
                        services={typeConfiguration?.services}
                        messageTemplate={typeConfiguration?.messageTemplate}
                        submit={async (e) => {
                            await submit(e);
                            reset({}, { keepValues: true });
                        }}
                    />
                )}
            </Form>
        </>
    );
};
